import React, { memo } from 'react';
import { Button, Form, Row, Col } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { CustomCol, StyledSelect } from '../style';
import {categoryTypeEnums} from "../constant"

const CasinoFilter = memo(({
  search,
  setSearch,
  statusFilter,
  setStatusFilter,
  setLimit,
  setPage,
  handleResetFilters,
  customColSetting,
  navigateReorder,
  categoryTypeFilter, setCategoryTypeFilter
}) => {
  return (
    <div className='FormsBg'>
      <Row className="g-2 align-items-center" style={{ rowGap: "0.25rem" }}>
        <CustomCol xs={12} md={4} lg={4}>
          <Form.Control
            type='search'
            placeholder='Search Name'
            size='sm'
            value={search}
            onChange={(event) =>
              setSearch(
                event.target.value.replace(/[~`!$%^&*#=)()><?]+/g, '')
              )}
            className="mb-2 mb-md-0"
          />
        </CustomCol>

        <CustomCol xs={12} md={3} lg={3}>
          <StyledSelect
            onChange={(e) => setStatusFilter(e.target.value)}
            value={statusFilter}
            size='sm'
            className="mb-2 mb-md-0"
          >
            <option value="">Filter by status</option>
            <option value="">All</option>
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </StyledSelect>
        </CustomCol>


        <CustomCol xs={12} md={3} lg={3}>
          <StyledSelect
            onChange={(e) => setCategoryTypeFilter(e.target.value)}
            value={categoryTypeFilter}
            size='sm'
            className="mb-2 mb-md-0"
          >
            <option value="">Filter by Category Type</option>
            <option value="">All</option>
            <option value={categoryTypeEnums?.featured}>Featured Category</option>
            <option value={categoryTypeEnums?.vault}>Category Vault</option>
          </StyledSelect>
        </CustomCol>




        {/* <Row className="g-2 align-items-center mt-2 mt-md-0">
          <Col xs={12} md={2} lg={3} className="d-flex w-100">
            <div className="d-flex w-100 mt-2 mt-md-0 justify-content-between">
              <Button
                className="d-flex align-items-center btn-primary gap-3"
                style={{ height: '2.2rem', minWidth: 'max-content' }}
                size="sm"
                onClick={handleResetFilters}
              >
                <span>Reset Filters</span>
                <FontAwesomeIcon icon={faRedoAlt} />
              </Button>
              <div>
              {customColSetting}
              </div>
              
            </div>
          </Col>
        </Row> */}

        <Row className="g-2 align-items-center mt-2 mt-md-0">
          <Col xs={12} md={10} lg={9}>
            <div className="d-flex flex-column flex-sm-row justify-content-start gap-2 w-100">
              <div className="order-2 order-md-1">
                <Button
                  className="d-flex align-items-center btn-primary gap-3"
                  style={{ height: '2.2rem', minWidth: 'max-content' }}
                  size="sm"
                  onClick={handleResetFilters}
                >
                  <span>Reset Filters</span>
                  <FontAwesomeIcon icon={faRedoAlt} />
                </Button>
              </div>
              <div>
                <Button
                  className="d-flex align-items-center btn-primary gap-3"
                  style={{ height: '2.2rem', minWidth: 'max-content' }}
                  size="sm"
                  onClick={navigateReorder}
                >
                  <span>Reorder Casino Category</span>

                </Button>
              </div>
            </div>
          </Col>
          <Col xs={12} md={2} lg={3}>
            <div className="d-flex justify-content-start justify-content-md-end">
              {customColSetting}
            </div>
          </Col>
        </Row>
      </Row>
    </div>
  );
});

export default CasinoFilter;